export default {
  notificationList: {
    method: 'post',
    url: '/company/user/notification/list'
  },
  notificationChangeRead: {
    method: 'put',
    url: '/company/user/notification'
  },
  notificationClearAll: {
    method: 'put',
    url: '/company/user/notification/clear-all'
  }
}
